import { render, staticRenderFns } from "./onSalePrice.vue?vue&type=template&id=06610f5a&scoped=true"
import script from "./onSalePrice.vue?vue&type=script&lang=js"
export * from "./onSalePrice.vue?vue&type=script&lang=js"
import style0 from "./onSalePrice.vue?vue&type=style&index=0&id=06610f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06610f5a",
  null
  
)

export default component.exports